/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_No_Plan_CtaInputs */

const en_us2_today_no_plan_cta = /** @type {(inputs: Today_No_Plan_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate my plan`)
};

const pt_br2_today_no_plan_cta = /** @type {(inputs: Today_No_Plan_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerar meu plano`)
};

const es_419_today_no_plan_cta = /** @type {(inputs: Today_No_Plan_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar mi plan`)
};

const pt_pt2_today_no_plan_cta = /** @type {(inputs: Today_No_Plan_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerar o meu plano`)
};

const fr_fr2_today_no_plan_cta = /** @type {(inputs: Today_No_Plan_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer mon programme`)
};

const de_de2_today_no_plan_cta = /** @type {(inputs: Today_No_Plan_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meinen Plan erstellen`)
};

const it_it2_today_no_plan_cta = /** @type {(inputs: Today_No_Plan_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera la mia scheda`)
};

/**
* | output |
* | --- |
* | "Generate my plan" |
*
* @param {Today_No_Plan_CtaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_no_plan_cta = /** @type {((inputs?: Today_No_Plan_CtaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_No_Plan_CtaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_no_plan_cta(inputs)
	if (locale === "es-419") return es_419_today_no_plan_cta(inputs)
	if (locale === "pt-PT") return pt_pt2_today_no_plan_cta(inputs)
	if (locale === "fr-FR") return fr_fr2_today_no_plan_cta(inputs)
	if (locale === "de-DE") return de_de2_today_no_plan_cta(inputs)
	if (locale === "it-IT") return it_it2_today_no_plan_cta(inputs)
	return en_us2_today_no_plan_cta(inputs)
});
export { today_no_plan_cta as "today.no_plan_cta" }